// Case data transformer

import { BaseTransformer } from './BaseTransformer';

export class CaseTransformer extends BaseTransformer {
  
  async transform(caseData: Record<string, unknown>): Promise<Record<string, unknown>> {
    console.log(`[CASE-TRANSFORM] Applying mapping rules:`);
    console.log(`   • templateData → populated_template`);
    console.log(`   • caseTemplateId/templateId → template_id`);
    console.log(`   • overviewSummary → summary`);
    console.log(`   • lID → location_id`);
    console.log(`   • pID/patientId → patient_id`);

    const templateId = (caseData as Record<string, unknown>)["caseTemplateId"] || (caseData as Record<string, unknown>)["templateId"];
    const payload = this.pruneUndefined({
      id: caseData.id,
      title: caseData.title,
      description: caseData.description,
      populated_template: caseData.templateData,
      summary: caseData.overviewSummary,
      location_id: caseData.lID,
      patient_id: (caseData as Record<string, unknown>)["pID"] || (caseData as Record<string, unknown>)["patientId"],
      groups: this.ensureArray(caseData.groups),
      owners: this.ensureArray(caseData.owners),
      archived: this.safeBoolean(caseData.archived),
      pinned: this.safeBoolean(caseData.pinned),
      created_at: caseData.createdAt || this.getCurrentTimestamp(),
      updated_at: this.getCurrentTimestamp()
    });

    // Explicitly set template_id only when present to avoid null overwrites
    if (templateId) {
      (payload as Record<string, unknown>)["template_id"] = templateId;
    }
    return payload;
  }
} 